var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100Z",
    fill: "#EA1C28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0538 34.1421C78.2433 41.9526 78.2433 54.6159 86.0538 62.4264L136.965 113.338C144.776 121.149 157.439 121.149 165.25 113.338C173.06 105.528 173.06 92.8643 165.25 85.0538L114.338 34.1421C106.528 26.3316 93.8643 26.3316 86.0538 34.1421Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8859 164.082C78.0754 156.272 78.0754 143.608 85.8859 135.798L136.798 84.8861C144.608 77.0756 157.271 77.0756 165.082 84.8861C172.892 92.6966 172.892 105.36 165.082 113.17L114.17 164.082C106.36 171.893 93.6964 171.893 85.8859 164.082Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1958 99.0001C69.1958 110.046 60.2415 119 49.1958 119C38.1501 119 29.1958 110.046 29.1958 99.0001C29.1958 87.9544 38.1501 79.0001 49.1958 79.0001C60.2415 79.0001 69.1958 87.9544 69.1958 99.0001Z",
    fill: "#FEF6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSf);
export default __webpack_public_path__ + "static/media/sf.1a4647a5f3281bb54c69210ed54fb9b0.svg";
export { ForwardRef as ReactComponent };